export const SSO_URL = "https://sso.simulanis.io";
// export const UNO_URL = "http://localhost:5000";

export const UNO_URL = "https://api.simulanis.io";
// export const UNO_URL = "http://localhost:3003";

export const applicationId = "19c180d8-cfeb-47e1-bcff-619591affbab";

export const defaultLogo = "https://cdn.simulanis.io/sso/logos/default_simulanis.png";
